import axios from 'axios';
import { apiString as api } from '../../utils/constants';
import { ProgramTypeEnum } from '../../Enum/ProgramTypeEnum';
import { IOnboardingDashboardDetail, OnboardingDashboardCardType } from '../../Models/Widget/OnboardingPerformanceDashboardDetail.model';
import { OnboardingWidgetDateRangeEnum } from '../../Enum/OnboardingWidgetDateRangeEnum';

export const fetchOnboardingDashboard = async (providerId: string, programType: ProgramTypeEnum, year: number, month: number) => {
    const response = await axios.get(`${api}/onboardingwidget/getonboardingdashboard`, { params: { providerId, programType, year, month } });
    return response.data;
};

export const fetchOnboardingDashboardDetails = async (
    cardType: OnboardingDashboardCardType,
    providerId: string,
    programType: ProgramTypeEnum,
    year: number,
    month: number,
    timeFilter?: OnboardingWidgetDateRangeEnum,
    dateFrom?: string,
    dateTo?: string) => {
    const response = await axios.get<IOnboardingDashboardDetail[]>(`${api}/onboardingwidget/getonboardingdashboarddetails`, { params: { cardType, providerId, programType, year, month, timeFilter, dateFrom, dateTo } });
    return response.data ?? [];
};

export const exportOnboardingDashboardDetails = async (
    cardType: OnboardingDashboardCardType,
    providerId: string,
    programType: ProgramTypeEnum,
    year: number,
    month: number,
    timeFilter?: OnboardingWidgetDateRangeEnum,
    dateFrom?: string,
    dateTo?: string) => {
    const response = await axios.get(`${api}/onboardingwidget/exportonboardingdashboarddetails`, { params: { cardType, providerId, programType, year, month, timeFilter, dateFrom, dateTo } });
    return response.data;
};